const API_ROUTES = {
  ADMIN_USERS: (search_str: string) => `/admin/admin-users${search_str}`,
  GET_ADMIN_USER: (admin_id: string) => `/admin/admin-users/${admin_id}`,
  ADMINS_RECIPIENTS: () => `/admin/admin-users/recipients`,
  ADMINS_PARTNERS: () => `/admin/admin-users/partners`,
  ADMINS_OB_CHECK: (recipient_id: string) => `/admin/recipients/${recipient_id}/onboarding`,
  ADMINS_ONBOARDING_FORM_COMPLETE: (recipient_id: string) =>
    `/admin/recipients/${recipient_id}/onboarding-complete`,
  PATCH_RECIPIENT_STRIPE_AUTHORIZED: (recipient_id: string) =>
    `/admin/recipients/${recipient_id}/set-stripe-authorized`,
  ADMINS_OB: `/accounts/stripe/onboarding`,
  ADMINS_USERS: '/admin/admin-users',
  ADMINS_USERS_ACCESS: (admin_id: string) => `/admin/admin-users/${admin_id}/access`,
  GET_PARTNERS: (search_str: string, partner_params: string) =>
    `/admin/partners${search_str}${partner_params}`,
  GET_DONATION_TOTAL: (start_date: string, end_date: string, client_id: string, page: string) =>
    `/admin/donation/total?start_date=${start_date}&end_date=${end_date}${client_id}${page}`,
  GET_DONATION_TREND: (start_date: string, end_date: string, client_id: string) =>
    `/admin/donation/trend?start_date=${start_date}&end_date=${end_date}${client_id}`,
  GET_PAGE_DETAIL: (query_str: string, category: string) => `/admin/pages/${category}/${query_str}`,
  GET_PAGES: (
    client_id: string | number,
    category: string,
    page_types: string,
    active_role: string
  ) => `/admin/pages${category}?client_id=${client_id}${page_types}&active_role=${active_role}`,
  GET_RECIPIENTS: (params: string) => `/admin/recipients/search${params}`,
  GET_SETS: (client_id: string | number) =>
    `/admin/sets${client_id ? `?client_id=${client_id}` : ''}`,
  POST_SETS: '/admin/sets',
  PUT_SET: (set_id: string) => `/admin/sets/${set_id}`,
  GET_ADMIN_RECIPIENTS: '/admin/recipients',
  GET_ADMIN_RECIPIENT: (recipient_id: string) => `/admin/recipients/${recipient_id}`,
  GET_TAGS: (query_str: string) => `/tags${query_str}`,
  GET_TABLE_DONORS: (start_date: string, end_date: string, client_id: string, page: string) =>
    `/admin/table/donors?start_date=${start_date}&end_date=${end_date}${client_id}${page}`,
  GET_TABLE_SUMMARY: (
    start_date: string,
    end_date: string,
    dimension: string,
    client_id: string,
    page: string
  ) =>
    `/admin/table/summary?start_date=${start_date}&end_date=${end_date}&dimension=${dimension}${client_id}${page}`,
  GET_TRANSACTION_TOTAL: (start_date: string, end_date: string, client_id: string) =>
    `/admin/transactions?start_date=${start_date}&end_date=${end_date}${client_id}`,
  GET_TRANSACTIONS_DISTINCT_RECIPIENTS: (params: string) =>
    `/admin/transactions/distinct_recipients${params}`,
  GET_USER: (email: string) => `/user?email=${email}`,
  GOOGLE_STORAGE_URL: (filename: string, file_type?: string, active_role?: string) =>
    `/admin/google_storage_url?filename=${filename}${file_type ? `&file_type=${file_type}` : ''}${active_role ? `&active_role=${active_role}` : ''}`,
  PAGES: (category: string, active_role: string) =>
    `/admin/pages/${category}?active_role=${active_role}`,
  TICKETS: '/admin/pages/event/tickets',
  CREATE_NON_PROFIT: (active_role: string, confirm_duplicate?: boolean) =>
    `/non_profit?active_role=${active_role}${confirm_duplicate ? '&confirm_duplicate=true' : ''}`,
  CREATE_CANDIDATE: (active_role: string) => `/admin/candidates?active_role=${active_role}`,
  GET_ELECTIONS: '/admin/elections',
  GET_RACES: (recipient_id: string) => `/admin/recipients/${recipient_id}/races`,
  CREATE_RACE: (recipient_id: string) => `/admin/recipients/${recipient_id}/races`,
  PATCH_RACE: (recipient_id: string, race_id: string) =>
    `/admin/recipients/${recipient_id}/races/${race_id}`,
  PATCH_ADMIN_RECIPIENT: (
    recipient_id: string,
    opts?: { confirmDuplicate?: boolean; clearChariotKeys?: boolean; reregisterChariot?: boolean }
  ) => {
    const params = new URLSearchParams();
    if (opts?.confirmDuplicate) params.append('confirm_duplicate', 'true');
    if (opts?.clearChariotKeys) params.append('clear_chariot_keys', 'true');
    if (opts?.reregisterChariot) params.append('reregister_chariot', 'true');
    const qs = params.toString();
    return `/admin/recipients/${recipient_id}${qs ? `?${qs}` : ''}`;
  },
  LOOKUP_RECIPIENTS: (
    display_name: string,
    exclude_recipient_id?: string,
    entity_type?: string
  ) => {
    const params = new URLSearchParams({ display_name });
    if (exclude_recipient_id) params.append('exclude_recipient_id', exclude_recipient_id);
    if (entity_type) params.append('entity_type', entity_type);
    return `/admin/recipients/lookup?${params}`;
  },
  GET_RECIPIENT_ADMINS: (recipient_id: string) => `/admin/recipients/${recipient_id}/admins`,
  POST_RECIPIENT_ADMIN: (recipient_id: string) => `/admin/recipients/${recipient_id}/admins`,
  POST_ARCHIVE_RECIPIENT_ADMIN: (recipient_id: string, admin_user_id: string) =>
    `/admin/recipients/${recipient_id}/admins/${admin_user_id}/archive`,
  POST_UNARCHIVE_RECIPIENT_ADMIN: (recipient_id: string, admin_user_id: string) =>
    `/admin/recipients/${recipient_id}/admins/${admin_user_id}/unarchive`,
  ACCOUNTS_LINK: '/accounts/stripe/account-link',
  GET_PAYOUTS: (recipient_id: string) => `/admin/recipients/${recipient_id}/stripe-payout-reports`,
  IMAGE_FILENAMES: (active_role: string) => `/admin/image_filenames?active_role=${active_role}`,
  SHOPPING_CART: (client_id: number | string) => `/admin/shopping-carts/${client_id}`,
  CLIENT_FILTERS: (client_id: number | string) => `/admin/clients/${client_id}/filters`,
  CLIENT_FILTER: (client_id: number | string, filter_id: string) =>
    `/admin/clients/${client_id}/filters/${filter_id}`,
};

export default API_ROUTES;
